import { render, staticRenderFns } from "./EmployeeConfig.vue?vue&type=template&id=69ba30d1"
import script from "./EmployeeConfig.vue?vue&type=script&lang=js"
export * from "./EmployeeConfig.vue?vue&type=script&lang=js"
import style0 from "./EmployeeConfig.vue?vue&type=style&index=0&id=69ba30d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports